"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Provider = Provider;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _context2 = require("./context");

var _debounce = require("./debounce");

var _jsxFileName = "/home/ackwell/code/xivanalysis/tooltips/src/provider.tsx";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var DEFAULT_DEBOUNCE_DELAY = 50;

function getWithDefault(map, key, factory) {
  var value = map.get(key);

  if (value == null) {
    value = factory();
    map.set(key, value);
  }

  return value;
}

function Provider(_ref) {
  var _ref$baseUrl = _ref.baseUrl,
      baseUrl = _ref$baseUrl === void 0 ? 'https://xivapi.com' : _ref$baseUrl,
      _ref$language = _ref.language,
      language = _ref$language === void 0 ? 'en' : _ref$language,
      _ref$debounceDelay = _ref.debounceDelay,
      debounceDelay = _ref$debounceDelay === void 0 ? DEFAULT_DEBOUNCE_DELAY : _ref$debounceDelay,
      children = _ref.children;
  var requestQueue = (0, _react.useRef)([]);
  var data = (0, _react.useRef)(); // Main request handler that hits the API. Debounced to prevent flooding requests.

  var initiateRequests = (0, _react.useCallback)(function () {
    // Grab references to the values we'll be processing this
    // execution, and clear out for the next consumer
    var currentQueue = requestQueue.current;
    requestQueue.current = []; // Build groups for requests to the same resource
    // I'm keying by the value in the cache as it'll be a stable reference

    var requestGroups = new Map();

    var _iterator = _createForOfIteratorHelper(currentQueue),
        _step;

    try {
      var _loop = function _loop() {
        var _step$value = (0, _slicedToArray2["default"])(_step.value, 4),
            Constructor = _step$value[0],
            language = _step$value[1],
            sheet = _step$value[2],
            id = _step$value[3];

        // Drill down to the pending IDs
        if (data.current == null) {
          data.current = new Map();
        }

        var languageCache = getWithDefault(data.current, Constructor, function () {
          return new Map();
        });
        var sheetCache = getWithDefault(languageCache, language, function () {
          return new Map();
        });
        var idCache = getWithDefault(sheetCache, sheet, function () {
          return new Map();
        }); // Make sure we have a set and add it

        var group = getWithDefault(requestGroups, idCache, function () {
          return {
            request: [Constructor, language, sheet],
            ids: new Set()
          };
        });
        group.ids.add(id);
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      } // Fetch the final data for the requests

    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    var promises = [];

    var _iterator2 = _createForOfIteratorHelper(requestGroups.entries()),
        _step2;

    try {
      var _loop2 = function _loop2() {
        var _Data$columns;

        var _step2$value = (0, _slicedToArray2["default"])(_step2.value, 2),
            cache = _step2$value[0],
            _step2$value$ = _step2$value[1],
            request = _step2$value$.request,
            ids = _step2$value$.ids;

        var _request = (0, _slicedToArray2["default"])(request, 3),
            Data = _request[0],
            language = _request[1],
            sheet = _request[2];

        var columns = [].concat((0, _toConsumableArray2["default"])(Object.keys((_Data$columns = Data.columns) !== null && _Data$columns !== void 0 ? _Data$columns : {})), ['ID']).join(',');
        var idsStr = (0, _toConsumableArray2["default"])(ids.values()).join(',');
        var promise = fetch("".concat(baseUrl, "/").concat(sheet, "?ids=").concat(idsStr, "&columns=").concat(columns, "&language=").concat(language)).then(function (resp) {
          return resp.json();
        }).then(function (_ref2) {
          var Results = _ref2.Results;

          // TODO: Handle pagination?
          // Save the fetched data into the data cache
          var _iterator3 = _createForOfIteratorHelper(Results),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var result = _step3.value;

              var _data = new Data();

              _data.hydrate(result, {
                baseUrl: baseUrl
              });

              cache.set(result.ID, {
                status: 'fulfilled',
                data: _data
              });
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        });
        promises.push(promise);
        ids.forEach(function (id) {
          return cache.set(id, {
            status: 'pending',
            promise: promise
          });
        });
      };

      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        _loop2();
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    return Promise.all(promises);
  }, [baseUrl]);
  var debouncedRequest = (0, _debounce.useAsyncDebounce)(initiateRequests, debounceDelay); // Cache value lookup

  var getCacheValue = (0, _react.useCallback)(function (_ref3) {
    var _data$current, _data$current$get, _data$current$get$get, _data$current$get$get2;

    var _ref4 = (0, _slicedToArray2["default"])(_ref3, 4),
        Columns = _ref4[0],
        language = _ref4[1],
        sheet = _ref4[2],
        id = _ref4[3];

    return (_data$current = data.current) === null || _data$current === void 0 ? void 0 : (_data$current$get = _data$current.get(Columns)) === null || _data$current$get === void 0 ? void 0 : (_data$current$get$get = _data$current$get.get(language)) === null || _data$current$get$get === void 0 ? void 0 : (_data$current$get$get2 = _data$current$get$get.get(sheet)) === null || _data$current$get$get2 === void 0 ? void 0 : _data$current$get$get2.get(id);
  }, []); // Convenience wrapper arouund the cache values to hide the promise structure from consumers

  var getCachedData = (0, _react.useCallback)(function (request) {
    var cacheValue = getCacheValue(request);
    return (cacheValue === null || cacheValue === void 0 ? void 0 : cacheValue.status) === 'fulfilled' ? cacheValue.data : undefined;
  }, [getCacheValue]); // Initiate a request for game data

  var requestGameData = (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(request) {
      var value;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // Check the cache to see if we need to do a request at all. It may have
              // already been fulfilled, or already be pending on network.
              value = getCacheValue(request);

              if (!((value === null || value === void 0 ? void 0 : value.status) === 'fulfilled')) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return", value.data);

            case 3:
              if (!((value === null || value === void 0 ? void 0 : value.status) === 'pending')) {
                _context.next = 7;
                break;
              }

              _context.next = 6;
              return value.promise;

            case 6:
              return _context.abrupt("return", getCachedData(request));

            case 7:
              // Push our request into the queue and wait for the request to resolve
              requestQueue.current.push(request);
              _context.next = 10;
              return debouncedRequest();

            case 10:
              return _context.abrupt("return", getCachedData(request));

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref5.apply(this, arguments);
    };
  }(), [getCachedData, getCacheValue, debouncedRequest]);
  var value = (0, _react.useMemo)(function () {
    return {
      baseUrl: baseUrl,
      defaultLanguage: language,
      getCachedData: getCachedData,
      requestGameData: requestGameData
    };
  }, [baseUrl, language, getCachedData, requestGameData]);
  return /*#__PURE__*/_react["default"].createElement(_context2.Context.Provider, {
    value: value,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 200,
      columnNumber: 9
    }
  }, children);
}